import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { SliceSliderRenderComponent } from './render/slice-slider-render.component';


export const sliceSliderRenderModuleEntryComponents = [
  SliceSliderRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    LazyLoadModule,
  ],
  declarations: sliceSliderRenderModuleEntryComponents
})
export class SliceSliderRenderModule {}

export default [
  SliceSliderRenderComponent
];
